import { ApiService, ApiServiceType } from "../../ApiService";
import store from "@/store";
import { WorkspaceUserDto } from "@/application/dtos/app/workspaces/WorkspaceUserDto";
import { WorkspaceDto } from "@/application/dtos/app/workspaces/WorkspaceDto";

export class WorkspaceService {
  api: ApiService;
  constructor() {
    this.api = new ApiService("Workspace", ApiServiceType.TenantDatabase);
  }
  adminGetAll(): Promise<WorkspaceDto[]> {
    return this.api.getAll(`Admin/GetAll`);
  }
  getAllWorkspaces(saveInStore: boolean = false): Promise<WorkspaceDto[]> {
    // store.commit("tenant/workspaces", []);
    return new Promise((resolve, reject) => {
      this.api
        .getAll("GetAll")
        .then((response: WorkspaceDto[]) => {
          resolve(JSON.parse(JSON.stringify(response)));
          if (saveInStore) {
            store.commit("tenant/workspaces", response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  get(id: string): Promise<WorkspaceDto> {
    return this.api.get("Get", id);
  }
  create(data: WorkspaceDto): Promise<WorkspaceDto> {
    return this.api.post(data);
  }
  addUser(id: string, data: WorkspaceUserDto): Promise<WorkspaceUserDto> {
    return this.api.post(data, "AddUser/" + id);
  }
  update(id: string, data: WorkspaceDto): Promise<WorkspaceDto> {
    return this.api.put(id, data);
  }
  removeUser(id: string): Promise<any> {
    return this.api.putRaw("RemoveUser/" + id);
  }
  delete(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api
        .delete(id)
        .then((response: any) => {
          resolve(this.api.getAll());
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  adminDelete(id: string): Promise<any> {
    return this.api.delete(id, "Admin/Delete");
  }
}
